import axios from "axios";

export default {
  namespaced: true,
  state: {
    bankaccounts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    bankaccountsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_BANK_ACCOUNTS(state, payload) {
      state.bankaccounts = payload;
      state.isReceiving = false;
    },
    RECEIVING_BANK_ACCOUNTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_BANK_ACCOUNT(state, payload) {
      state = Object.assign(state, {
        bankaccounts: [...state.bankaccounts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_BANK_ACCOUNT(state) {
      state.isReceiving = true;
    },
    UPDATED_BANK_ACCOUNT(state, payload) {
      let index = state.bankaccounts.findIndex(bankaccount => bankaccount._id === payload._id);
      state = Object.assign(state, {
        bankaccounts: state.bankaccounts.map((bankaccount, i) => {
          if (i === index) {
            return Object.assign({}, bankaccount, payload);
          }
          return bankaccount;
        }),
        isUpdating: false,
        bankaccountsMessage: 'BankAccounts has been updating!',
      })
    },
    UPDATING_BANK_ACCOUNT(state) {
      state.isUpdating = true;
    },
    DELETED_BANK_ACCOUNT(state, payload) {
      let indexToDelete = state.bankaccounts.findIndex(bankaccount => bankaccount._id === payload._id);
      let bankaccounts = [...state.bankaccounts];
      bankaccounts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        bankaccounts: [...bankaccounts],
        isDeleting: false,
        idToDelete: null,
        bankaccountsMessage: 'BankAccount has been Deleted!',
      });
    },
    DELETING_BANK_ACCOUNT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteBankAccountRequest({dispatch}, payload) {
      dispatch("deletingBankAccount", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/bankaccount/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        dispatch("deleteBankAccount", response.data);
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteBankStatementRequest({dispatch}, payload) {
      try{
        dispatch("doNothing", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/bankstatement/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getBankAccountsRequest({dispatch}) {
      dispatch("receivingBankAccounts");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/bankaccounts';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveBankAccounts", res.data);
      })
    },
    async insertBankAccountRequest({dispatch}, payload) {
      dispatch("receivingBankAccount");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/bankaccount';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        console.log(response.data)
        dispatch("receiveBankAccount", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertBankStatementRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log(payload);
        console.log(token)
        let url = 'https://api.tradexc.com:3000/insert/bankstatement/' + payload.id;
        console.log(url)
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertBankStatementWithFileRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/bankstatement/withfile/' + payload.id;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateBankAccountRequest({dispatch}, payload) {
      dispatch("updatingBankAccount");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/bankaccount/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateBankAccount", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateBankStatementRequest({dispatch}, payload) {
      try{
        console.log(payload)
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/bankstatement/' + payload.id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveBankAccounts({commit}, payload) {
      commit("RECEIVED_BANK_ACCOUNTS", payload)
    },
    receivingBankAccounts({commit}) {
      commit("RECEIVING_BANK_ACCOUNTS")
    },
    receiveBankAccount({commit}, payload) {
      commit("RECEIVED_BANK_ACCOUNT", payload)
    },
    receivingBankAccount({commit}) {
      commit("RECEIVING_BANK_ACCOUNT")
    },
    updateBankAccount({commit}, payload) {
      commit("UPDATED_BANK_ACCOUNT", payload)
    },
    updatingBankAccount({commit}) {
      commit("UPDATING_BANK_ACCOUNT")
    },
    deleteBankAccount({commit}, payload) {
      commit("DELETED_BANK_ACCOUNT", payload)
    },
    deletingBankAccount({commit}, payload) {
      commit("DELETING_BANK_ACCOUNT", payload)
    }
  },
};
